export var FlightPivots;
(function (FlightPivots) {
    FlightPivots["details"] = "details";
    FlightPivots["variables"] = "variables";
    FlightPivots["traffic"] = "traffic";
    FlightPivots["composition"] = "composition";
    FlightPivots["archivedByExp"] = "-archivedbyexp";
})(FlightPivots || (FlightPivots = {}));
export var FlightViewConstants;
(function (FlightViewConstants) {
    FlightViewConstants["edit"] = "edit";
    FlightViewConstants["compositionEdit"] = "compositionEdit";
})(FlightViewConstants || (FlightViewConstants = {}));
export const BING_SETFLIGHT_LINK = 'https://bing.com/corpnet/signin?returnurl=https%3A%2F%2Fwww.bing.com%2F%3Fsetflight%3D';
export const BING_EXPANDED_FEATURE_LINK = 'https://www.bing.com/search?q=test&features=';

//# sourceMappingURL=flight.constants.js.map
